import React, { useEffect, useMemo, useRef, useState } from "react";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import { useMutateUpdateUserMessage } from "../hooks/useApihook";
import { Field, Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { GetUserMessage } from "../../../../Api/setting";
import {
  getValidationSchema,
  UpdateAiChatIntialValues,
  UpdateAiChatValidationSchema,
} from "./constant";
import SettingTextArea from "./SettingTextArea";
import SaveButton from "../../../../Components/SaveButton";
import Select from "react-select";

const Aichatusersetting = () => {
  const navigate = useNavigate();
  const formRef = useRef();
  const [copied, setCopied] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [originalMessage, setOriginalMessage] = useState("");
  const [selectedType, setSelectedType] = useState("userMessage");

  const promptData = [
    {
      label: "Free User Chatbot",
      value: "userMessage",
      dynamicVariables: [
        {
          value: "message",
          description: "User Message",
        },
        {
          value: "age",
          description: "User Age",
        },
        {
          value: "birthDate",
          description: "User BirthDate",
        },
      ],
    },
    // {
    //   label: "Period Cycle Prediction",
    //   value: "userPeriodCycle",
    //   dynamicVariables: [
    //     {
    //       value: "",
    //       description: "",
    //     },
    //   ],
    // },
    // {
    //   label: "User Daily Questions",
    //   value: "userDailyQuestion",
    //   dynamicVariables: [
    //     {
    //       value: "",
    //       description: "",
    //     },
    //   ],
    // },
    // {
    //   label: "Generate Lesson Tags",
    //   value: "generateLessonTags",
    //   dynamicVariables: [
    //     {
    //       value: "",
    //       description: "",
    //     },
    //   ],
    // },
    // {
    //   label: "Suggest Lesson Products",
    //   value: "suggestLessonProducts",
    //   dynamicVariables: [
    //     {
    //       value: "",
    //       description: "",
    //     },
    //   ],
    // },
    // {
    //   label: "Generate Daily Insights",
    //   value: "generateDailyInsights",
    //   dynamicVariables: [
    //     {
    //       value: "",
    //       description: "",
    //     },
    //   ],
    // },
  ];

  const apiType = useMemo(() => {
    const selected = promptData.find((p) => p.value === selectedType);
    return (selected && selected.value) || selectedType;
  }, [selectedType]);

  const fetchUserMessage = async (type) => {
    setIsLoading(true);
    try {
      const response = await GetUserMessage(type);
      if (!response.data.data || Object.keys(response.data.data).length === 0) {
        ErrorToast(response.data.message || "No data found");
        setIsLoading(false);
        if (formRef.current) {
          formRef.current.setValues({ message: "" });
        }
        setData(null);
        setOriginalMessage("");
        return;
      }
      const fetchedMessage = response.data.data.message || "";
      if (formRef.current) {
        formRef.current.setValues({ message: response.data.data.message });
      }
      setData(response);
      setOriginalMessage(fetchedMessage);
    } catch (error) {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (data) {
      UpdateAiChatIntialValues.message = data.data.data.message;
      if (formRef.current) {
        formRef.current.setValues({ message: data.data.data.message });
      }
    } else {
      UpdateAiChatIntialValues.message = "";
      if (formRef.current) {
        formRef.current.setValues({ message: "" });
      }
    }
  }, [data]);

  useEffect(() => {
    fetchUserMessage(selectedType);
  }, [])

  const updateUserMessageApi = useMutateUpdateUserMessage();

  const handleSubmitEditUserMessage = (values, { setSubmitting }) => {
    const reqData = { name: apiType, message: values.message || "" };
    setIsSaving(true);
    updateUserMessageApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response.message || "User Message Updated.");
        setOriginalMessage(values.message);
        if (formRef.current) {
          formRef.current.setValues({ message: values.message });
        }
        setSubmitting(false);
        navigate("/admin/setting");
        setIsSaving(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        setSubmitting(false);
        setIsSaving(false);
      },
    });
  };

  const handleCopy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <div className="setting-border overflow-visible">
      <div className="">
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">Select Prompt</label>
              <Select
                options={promptData.map((p) => ({
                  label: p.label,
                  value: p.value,
                }))}
                placeholder="Select Prompt"
                value={
                  promptData
                    .map((p) => ({ label: p.label, value: p.value }))
                    .find((o) => o.value === selectedType) || null
                }
                onChange={(option) => {
                  setSelectedType(option ? option.value : ""),
                    fetchUserMessage(option ? option.value : "")
                }
                }
                isClearable={false}
                theme={(base) => ({
                  ...base,
                  colors: {
                    ...base.colors,
                    primary: "#AD5ADC",
                    primary25: "#E8DBF3",
                    primary50: "#D2B9EA",
                  },
                })}
                styles={{
                  container: (styles) => ({
                    ...styles,
                    width: "100%",
                  }),
                  option: (styles, { isDisabled }) => ({
                    ...styles,
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    marginTop: "0px",
                    marginBottom: "0px",
                    backgroundColor: styles.backgroundColor,
                  }),
                  control: (styles, state) => ({
                    ...styles,
                    border: state.isFocused
                      ? "2px solid #AD5ADC"
                      : "2px solid #00000061",
                    boxShadow: state.isFocused ? "0 0 0 1px #AD5ADC" : "none",
                    borderRadius: "10px",
                    minHeight: 40,
                    paddingLeft: 6,
                    ":hover": {
                      borderColor: state.isFocused ? "#AD5ADC" : "#cfcfcf",
                    },
                  }),

                  placeholder: (styles) => ({
                    ...styles,
                    color: "#6b6b6b",
                  }),
                  singleValue: (styles) => ({
                    ...styles,
                    color: "#000",
                    fontWeight: 400,
                  }),
                  dropdownIndicator: (styles, state) => ({
                    ...styles,
                    color: state.isFocused ? "#AD5ADC" : "#6b6b6b",
                    ":hover": { color: "#AD5ADC" },
                  }),
                  menu: (styles) => ({
                    ...styles,
                    borderRadius: "20px",
                    overflow: "hidden",
                    cursor: "pointer",
                  }),
                  option: (styles, { isFocused, isSelected }) => ({
                    ...styles,
                    backgroundColor: isSelected
                      ? "#E8DBF3"
                      : isFocused
                        ? "#F5ECFA"
                        : "#fff",
                    color: "#000",
                  }),
                }}
              />
            </div>
            {(() => {
              const selectedPrompt = promptData.find(
                (p) => p.value === selectedType
              );
              const variables =
                selectedPrompt && Array.isArray(selectedPrompt.dynamicVariables)
                  ? selectedPrompt.dynamicVariables.filter((v) => v && v.value)
                  : [];
              if (!variables.length) return null;
              return (
                <table className="aichat-table setting-table table align-items-center table--light">
                  <thead className="thead-light">
                    <tr>
                      <th>Short Code</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td align="center" colSpan={2}>
                          <div className="d-flex justify-content-center align-items-center py-4">
                            <div
                              className="spinner-border loader-theme"
                              role="status"
                            />
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <>
                        {variables.map((v) => (
                          <tr key={v.value}>
                            <td>
                              <span
                                className={`copyable-text ${copied === v.value ? "copied" : ""}`}
                                onClick={() =>
                                  handleCopy(`{{${v.value}}}`, v.value)
                                }
                              >
                                <span className="text">{`{{${v.value}}}`}</span>
                                <span className="copy-label">Copy</span>
                                <span className="copied-label">Copied</span>
                              </span>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {v.description || v.value}
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              );
            })()}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="">
              <Formik
                initialValues={UpdateAiChatIntialValues}
                validationSchema={getValidationSchema((
                  promptData.find((p) => p.value === selectedType)
                    ?.dynamicVariables || []
                ).filter((v) => v && v.value)
                )}
                validateOnChange
                innerRef={formRef}
                onSubmit={handleSubmitEditUserMessage}
              >
                {(formik) => {
                  const { isSubmitting } = formik;
                  return (
                    <Form>
                      <div className="row">
                        <div className="col-md-12">
                          <Field
                            Label="Chatbot Prompt Message"
                            name="message"
                            placeholder="Enter Chatbot Prompt Message"
                            component={SettingTextArea}
                          />
                        </div>
                      </div>
                      <SaveButton
                        loading={isSaving}
                        disabled={
                          isSaving || formik.values.message === originalMessage // ✅ disable if unchanged
                        }
                      />
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aichatusersetting;
